import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

export default function BuyerForm({
  initialValues,
  title,
  send,
  error,
  success,
  loading,
}) {
  const [emailVerification, setEmailVerification] = useState(false);
  const [passwordVerification, setPasswordVerification] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setEmailVerification(false);
    setPasswordVerification(false);
    // setPasswordValidation(false);

    let emailVerification = new RegExp(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    ).test(values.email);

    if (emailVerification === false) {
      setEmailVerification(true);
      return false;
    }

    let passwordValidation = new RegExp(
      /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/gm
    ).test(values.senha);

    if (passwordValidation === false) {
      setPasswordVerification(true);
      return false;
    }

    send(values);
  };

  return (
    <div className="user-container">
      {error && <span className="error-list">{error && error}</span>}
      {success && <span className="success-msg">Salvo com sucesso.</span>}
      <div className="header-container">
        <div className="public-app-item">
          <h1>Seja bem vindo a CTAG</h1>
          <p>
            Nós tornamos a sua experiência mais fácil, maximizando seu tempo
          </p>
        </div>
      </div>
      <form className="form-container-two-column" onSubmit={handleSubmit}>
        <div className="group-input">
          <input
            placeholder="Nome do usuario *"
            className={`global-input ${
              submitted && !values.nome ? "error" : ""
            }`}
            id="nome"
            name="nome"
            value={values.nome}
            onChange={handleChange}
          />
          {submitted && !values.nome && (
            <span className="error-msg">Esse campo é necessario</span>
          )}
        </div>
        <div className="group-input">
          <input
            placeholder="Email *"
            className={`global-input ${
              submitted && !values.email ? "error" : ""
            }`}
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
          />
          {submitted && !values.email && (
            <span className="error-msg">Esse campo é necessario</span>
          )}
          {emailVerification && (
            <span className="error-msg">Insira um e-mail válido</span>
          )}
        </div>
        <div className="form-footer-btn">
          <div className="group-input">
            {/* <input
              type="senha"
              placeholder="Senha *"
              className={`global-input ${
                submitted && passwordVerification ? "error" : ""
              }`}
              id="senha"
              name="senha"
              type="password"
              value={values.senha}
              onChange={handleChange}
            /> */}
            {passwordVerification && (
              <span className="error-msg">
                A senha deve conter no mínimo de 8 caracteres alternados com
                letras, números e caracteres
              </span>
            )}
            {submitted && !values.senha && (
              <span className="error-msg">Esse campo é necessario</span>
            )}
          </div>
        </div>
        <div className="footer-form-container">
          <div className="footer-form-item">
            <div className="link-container">
              <p>
                {" "}
                ou <a href="/login">login</a>{" "}
              </p>
            </div>
          </div>
          <div className="footer-form-item">
            <button className="global-btn">
              Criar conta{" "}
              {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
